import {NavLink} from 'react-router-dom';
import {Box, Breadcrumbs} from '@mantine/core';

import {UsageEvent} from '../types';
import {moduleConfig} from '../config';

export const EditPageNavigation = ({component}: { component: UsageEvent }) => {

    const breadcrumbs = [
        {title: 'Home', href: '/dashboard'},
        {title: `${moduleConfig.titles.plural}`, href: `/usage-events`},
        {title: component.eventId},
    ].map((item, index) => (
        <Box key={index}>
            {item.href ? <NavLink to={item.href}>{item.title}</NavLink> : item.title}
        </Box>
    ));

    return (
        <Box p={'xs'}><Breadcrumbs separator='→' mt='xs'>{breadcrumbs}</Breadcrumbs></Box>
    );
};
